import { z } from "zod";
export const TcsionConnectInputSchema = z.object({
    /** Raw 'u' token from the TCS iON API URL */
    userToken: z.string().min(10),
});
export const TcsionStatusOutputSchema = z.object({
    connected: z.boolean(),
    status: z.enum(["active", "paused", "error"]).nullable(),
    dataAvailable: z.boolean(),
    lastSyncedAt: z.string().nullable(),
    lastSyncStatus: z
        .enum(["running", "fetching", "fetched", "transforming", "succeeded", "failed"])
        .nullable(),
    error: z.string().nullable(),
});
